var _circle, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoPolicies(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 348,
    height: 348,
    viewBox: "0 0 348 348",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 174,
    cy: 174,
    r: 174,
    fill: "#2A2A2A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M174 121.144C177.783 121.144 180.665 118.082 180.665 114.479V94.6648C180.665 90.8821 177.603 88 174 88C170.217 88 167.335 91.0622 167.335 94.6648V114.479C167.335 118.082 170.217 121.144 174 121.144Z",
    fill: "#A0A0A0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M199.759 128.529C200.839 129.25 202.1 129.61 203.361 129.61C205.523 129.61 207.865 128.529 209.126 126.368L219.573 109.616C221.555 106.373 220.654 102.23 217.412 100.249C214.169 98.2675 210.026 99.1681 208.045 102.41L197.597 119.163C195.616 122.405 196.516 126.548 199.759 128.529Z",
    fill: "#A0A0A0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M138.874 126.368C140.135 128.349 142.297 129.61 144.639 129.61C145.9 129.61 147.16 129.25 148.241 128.529C151.484 126.548 152.384 122.405 150.403 119.163L139.955 102.41C137.974 99.1681 133.831 98.2675 130.588 100.249C127.346 102.23 126.445 106.373 128.427 109.616L138.874 126.368Z",
    fill: "#A0A0A0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M149.682 221.657L112.395 207.066V235.887C112.395 238.049 113.836 240.03 115.818 240.751L169.857 259.124V203.284L154.546 220.576C153.285 221.837 151.304 222.378 149.682 221.657Z",
    fill: "#A0A0A0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M253.438 187.612L234.884 164.195C234.344 163.115 233.263 162.394 232.182 162.034L175.621 142.76C174.54 142.4 173.46 142.4 172.379 142.76L115.818 162.034C114.737 162.394 113.656 163.295 113.116 164.195L94.5623 187.612C93.4815 188.873 94.0219 190.855 95.6431 191.575L148.421 212.29C149.322 212.651 150.583 212.47 151.304 211.57L170.938 189.594C172.559 187.793 175.621 187.793 177.242 189.594L196.877 211.57C197.597 212.29 198.678 212.651 199.759 212.29L252.357 191.395C253.978 190.855 254.518 188.873 253.438 187.612ZM174 180.587L133.11 166.717L174 152.847L214.89 166.717L174 180.587Z",
    fill: "#A0A0A0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M196.697 222.017C195.436 222.017 194.355 221.477 193.454 220.576L178.143 203.284V258.944L232.182 240.571C234.164 239.85 235.605 237.869 235.605 235.707V206.886L198.318 221.477C197.777 221.837 197.237 222.017 196.697 222.017Z",
    fill: "#A0A0A0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPolicies);
export default __webpack_public_path__ + "static/media/no-policies.f07cd9deff0e7c32a9286fc3409c36a8.svg";
export { ForwardRef as ReactComponent };